class SurfaceSwatchModal extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.querySelector('[role="dialog"]');
    this.mediaEl = this.querySelector('[data-surface-modal-media]');
    this.infoEl = this.querySelector('[data-surface-modal-info]');
    this.prevButton = this.querySelector('[data-surface-modal-prev]');
    this.nextButton = this.querySelector('[data-surface-modal-next]');

    this.currentIndex = -1;
    this.openedBy = null;

    this.onKeyup = this.onKeyup.bind(this);

    this.querySelectorAll('[data-surface-modal-close]').forEach((button) => {
      button.addEventListener('click', () => this.close());
    });

    this.addEventListener('click', (event) => {
      if (event.target === this) this.close();
    });

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.step(-1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.step(1));
  }

  connectedCallback() {
    const section = this.closest('.shopify-section') || document;
    this.triggers = Array.from(section.querySelectorAll('[data-surface-open]'));

    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => this.open(index));
    });
  }

  get loop() {
    return this.triggers.length > 1;
  }

  open(index) {
    if (!this.triggers || !this.triggers[index]) return;

    this.openedBy = this.triggers[index];
    this.render(index);

    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    document.addEventListener('keyup', this.onKeyup);

    if (typeof trapFocus === 'function') {
      trapFocus(this, this.dialog);
    } else if (this.dialog) {
      this.dialog.focus();
    }
  }

  close() {
    if (!this.hasAttribute('open')) return;

    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    document.removeEventListener('keyup', this.onKeyup);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.openedBy);
    } else if (this.openedBy) {
      this.openedBy.focus();
    }

    this.currentIndex = -1;
  }

  step(direction) {
    if (!this.loop) return;

    const total = this.triggers.length;
    const next = (this.currentIndex + direction + total) % total;
    this.render(next);
  }

  onKeyup(event) {
    if (!this.hasAttribute('open')) return;

    switch (event.code) {
      case 'Escape':
        this.close();
        break;
      case 'ArrowLeft':
        this.step(-1);
        break;
      case 'ArrowRight':
        this.step(1);
        break;
    }
  }

  render(index) {
    const trigger = this.triggers[index];
    if (!trigger) return;

    this.currentIndex = index;

    if (this.mediaEl) {
      const image = document.createElement('img');
      image.src = trigger.dataset.imageSrc || '';
      if (trigger.dataset.imageSrcset) image.srcset = trigger.dataset.imageSrcset;
      image.sizes = '(min-width: 990px) 60vw, 100vw';
      image.alt = trigger.dataset.imageAlt || '';
      if (trigger.dataset.imageWidth) image.width = trigger.dataset.imageWidth;
      if (trigger.dataset.imageHeight) image.height = trigger.dataset.imageHeight;
      image.className = 'weber-surface-modal__image';

      this.mediaEl.replaceChildren(image);
    }

    if (this.infoEl) {
      const template = trigger.parentElement.querySelector('template[data-surface-info]');
      this.infoEl.replaceChildren(template ? template.content.cloneNode(true) : document.createTextNode(''));
      this.infoEl.scrollTop = 0;
    }

    const label = trigger.dataset.imageAlt;
    if (label && this.dialog) this.dialog.setAttribute('aria-label', label);
  }
}

customElements.define('surface-swatch-modal', SurfaceSwatchModal);
